const countryMap = [
  { isoCode: 'GB', name: 'United Kingdom' },
  { isoCode: 'AU', name: 'Australia' },
  { isoCode: 'US', name: 'United States of America' },
  { isoCode: 'AF', name: 'Afghanistan' },
  { isoCode: 'AL', name: 'Albania' },
  { isoCode: 'AD', name: 'Andorra' },
  { isoCode: 'AO', name: 'Angola' },
  { isoCode: 'AI', name: 'Anguilla' },
  { isoCode: 'AQ', name: 'Antarctica' },
  { isoCode: 'AG', name: 'Antigua and Barbuda' },
  { isoCode: 'AM', name: 'Armenia' },
  { isoCode: 'AE', name: 'United Arab Emirates' },
  { isoCode: 'AR', name: 'Argentina' },
  { isoCode: 'AS', name: 'American Samoa' },
  { isoCode: 'AT', name: 'Austria' },
  { isoCode: 'AW', name: 'Aruba' },
  { isoCode: 'AX', name: 'Åland Islands' },
  { isoCode: 'AZ', name: 'Azerbaijan' },
  { isoCode: 'BA', name: 'Bosnia and Herzegovina' },
  { isoCode: 'BB', name: 'Barbados' },
  { isoCode: 'BD', name: 'Bangladesh' },
  { isoCode: 'BE', name: 'Belgium' },
  { isoCode: 'BF', name: 'Burkina Faso' },
  { isoCode: 'BG', name: 'Bulgaria' },
  { isoCode: 'BH', name: 'Bahrain' },
  { isoCode: 'BI', name: 'Burundi' },
  { isoCode: 'BJ', name: 'Benin' },
  { isoCode: 'BL', name: 'Saint Barthélemy' },
  { isoCode: 'BM', name: 'Bermuda' },
  { isoCode: 'BN', name: 'Brunei Darussalam' },
  { isoCode: 'BO', name: 'Bolivia, Plurinational State of' },
  { isoCode: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
  { isoCode: 'BR', name: 'Brazil' },
  { isoCode: 'BS', name: 'Bahamas' },
  { isoCode: 'BT', name: 'Bhutan' },
  { isoCode: 'BV', name: 'Bouvet Island' },
  { isoCode: 'BW', name: 'Botswana' },
  { isoCode: 'BY', name: 'Belarus' },
  { isoCode: 'BZ', name: 'Belize' },
  { isoCode: 'CA', name: 'Canada' },
  { isoCode: 'CC', name: 'Cocos (Keeling) Islands' },
  { isoCode: 'CD', name: 'Congo, the Democratic Republic of the' },
  { isoCode: 'CF', name: 'Central African Republic' },
  { isoCode: 'CG', name: 'Congo' },
  { isoCode: 'CH', name: 'Switzerland' },
  { isoCode: 'CI', name: "Côte d'Ivoire" },
  { isoCode: 'CK', name: 'Cook Islands' },
  { isoCode: 'CL', name: 'Chile' },
  { isoCode: 'CM', name: 'Cameroon' },
  { isoCode: 'CN', name: 'China' },
  { isoCode: 'CO', name: 'Colombia' },
  { isoCode: 'CR', name: 'Costa Rica' },
  { isoCode: 'CU', name: 'Cuba' },
  { isoCode: 'CV', name: 'Cabo Verde' },
  { isoCode: 'CW', name: 'Curaçao' },
  { isoCode: 'CX', name: 'Christmas Island' },
  { isoCode: 'CY', name: 'Cyprus' },
  { isoCode: 'CZ', name: 'Czechia' },
  { isoCode: 'DE', name: 'Germany' },
  { isoCode: 'DJ', name: 'Djibouti' },
  { isoCode: 'DK', name: 'Denmark' },
  { isoCode: 'DM', name: 'Dominica' },
  { isoCode: 'DO', name: 'Dominican Republic' },
  { isoCode: 'DZ', name: 'Algeria' },
  { isoCode: 'EC', name: 'Ecuador' },
  { isoCode: 'EE', name: 'Estonia' },
  { isoCode: 'EG', name: 'Egypt' },
  { isoCode: 'EH', name: 'Western Sahara' },
  { isoCode: 'ER', name: 'Eritrea' },
  { isoCode: 'ES', name: 'Spain' },
  { isoCode: 'ET', name: 'Ethiopia' },
  { isoCode: 'FI', name: 'Finland' },
  { isoCode: 'FJ', name: 'Fiji' },
  { isoCode: 'FK', name: 'Falkland Islands (Malvinas)' },
  { isoCode: 'FM', name: 'Micronesia, Federated States of' },
  { isoCode: 'FO', name: 'Faroe Islands' },
  { isoCode: 'FR', name: 'France' },
  { isoCode: 'GA', name: 'Gabon' },
  { isoCode: 'GD', name: 'Grenada' },
  { isoCode: 'GE', name: 'Georgia' },
  { isoCode: 'GF', name: 'French Guiana' },
  { isoCode: 'GG', name: 'Guernsey' },
  { isoCode: 'GH', name: 'Ghana' },
  { isoCode: 'GI', name: 'Gibraltar' },
  { isoCode: 'GL', name: 'Greenland' },
  { isoCode: 'GM', name: 'Gambia' },
  { isoCode: 'GN', name: 'Guinea' },
  { isoCode: 'GP', name: 'Guadeloupe' },
  { isoCode: 'GQ', name: 'Equatorial Guinea' },
  { isoCode: 'GR', name: 'Greece' },
  { isoCode: 'GS', name: 'South Georgia and the South Sandwich Islands' },
  { isoCode: 'GT', name: 'Guatemala' },
  { isoCode: 'GU', name: 'Guam' },
  { isoCode: 'GW', name: 'Guinea-Bissau' },
  { isoCode: 'GY', name: 'Guyana' },
  { isoCode: 'HK', name: 'Hong Kong' },
  { isoCode: 'HM', name: 'Heard Island and McDonald Islands' },
  { isoCode: 'HN', name: 'Honduras' },
  { isoCode: 'HR', name: 'Croatia' },
  { isoCode: 'HT', name: 'Haiti' },
  { isoCode: 'HU', name: 'Hungary' },
  { isoCode: 'ID', name: 'Indonesia' },
  { isoCode: 'IE', name: 'Ireland' },
  { isoCode: 'IL', name: 'Israel' },
  { isoCode: 'IM', name: 'Isle of Man' },
  { isoCode: 'IN', name: 'India' },
  { isoCode: 'IO', name: 'British Indian Ocean Territory' },
  { isoCode: 'IQ', name: 'Iraq' },
  { isoCode: 'IR', name: 'Iran, Islamic Republic of' },
  { isoCode: 'IS', name: 'Iceland' },
  { isoCode: 'IT', name: 'Italy' },
  { isoCode: 'JE', name: 'Jersey' },
  { isoCode: 'JM', name: 'Jamaica' },
  { isoCode: 'JO', name: 'Jordan' },
  { isoCode: 'JP', name: 'Japan' },
  { isoCode: 'KE', name: 'Kenya' },
  { isoCode: 'KG', name: 'Kyrgyzstan' },
  { isoCode: 'KH', name: 'Cambodia' },
  { isoCode: 'KI', name: 'Kiribati' },
  { isoCode: 'KM', name: 'Comoros' },
  { isoCode: 'KN', name: 'Saint Kitts and Nevis' },
  { isoCode: 'KP', name: "Korea, Democratic People's Republic of" },
  { isoCode: 'KR', name: 'Korea, Republic of' },
  { isoCode: 'KW', name: 'Kuwait' },
  { isoCode: 'KY', name: 'Cayman Islands' },
  { isoCode: 'KZ', name: 'Kazakhstan' },
  { isoCode: 'LA', name: "Lao People's Democratic Republic" },
  { isoCode: 'LB', name: 'Lebanon' },
  { isoCode: 'LC', name: 'Saint Lucia' },
  { isoCode: 'LI', name: 'Liechtenstein' },
  { isoCode: 'LK', name: 'Sri Lanka' },
  { isoCode: 'LR', name: 'Liberia' },
  { isoCode: 'LS', name: 'Lesotho' },
  { isoCode: 'LT', name: 'Lithuania' },
  { isoCode: 'LU', name: 'Luxembourg' },
  { isoCode: 'LV', name: 'Latvia' },
  { isoCode: 'LY', name: 'Libya' },
  { isoCode: 'MA', name: 'Morocco' },
  { isoCode: 'MC', name: 'Monaco' },
  { isoCode: 'MD', name: 'Moldova, Republic of' },
  { isoCode: 'ME', name: 'Montenegro' },
  { isoCode: 'MF', name: 'Saint Martin (French part)' },
  { isoCode: 'MG', name: 'Madagascar' },
  { isoCode: 'MH', name: 'Marshall Islands' },
  { isoCode: 'MK', name: 'Macedonia, the former Yugoslav Republic of' },
  { isoCode: 'ML', name: 'Mali' },
  { isoCode: 'MM', name: 'Myanmar' },
  { isoCode: 'MN', name: 'Mongolia' },
  { isoCode: 'MO', name: 'Macao' },
  { isoCode: 'MP', name: 'Northern Mariana Islands' },
  { isoCode: 'MQ', name: 'Martinique' },
  { isoCode: 'MR', name: 'Mauritania' },
  { isoCode: 'MS', name: 'Montserrat' },
  { isoCode: 'MT', name: 'Malta' },
  { isoCode: 'MU', name: 'Mauritius' },
  { isoCode: 'MV', name: 'Maldives' },
  { isoCode: 'MW', name: 'Malawi' },
  { isoCode: 'MX', name: 'Mexico' },
  { isoCode: 'MY', name: 'Malaysia' },
  { isoCode: 'MZ', name: 'Mozambique' },
  { isoCode: 'NA', name: 'Namibia' },
  { isoCode: 'NC', name: 'New Caledonia' },
  { isoCode: 'NE', name: 'Niger' },
  { isoCode: 'NF', name: 'Norfolk Island' },
  { isoCode: 'NG', name: 'Nigeria' },
  { isoCode: 'NI', name: 'Nicaragua' },
  { isoCode: 'NL', name: 'Netherlands' },
  { isoCode: 'NO', name: 'Norway' },
  { isoCode: 'NP', name: 'Nepal' },
  { isoCode: 'NR', name: 'Nauru' },
  { isoCode: 'NU', name: 'Niue' },
  { isoCode: 'NZ', name: 'New Zealand' },
  { isoCode: 'OM', name: 'Oman' },
  { isoCode: 'PA', name: 'Panama' },
  { isoCode: 'PE', name: 'Peru' },
  { isoCode: 'PF', name: 'French Polynesia' },
  { isoCode: 'PG', name: 'Papua New Guinea' },
  { isoCode: 'PH', name: 'Philippines' },
  { isoCode: 'PK', name: 'Pakistan' },
  { isoCode: 'PL', name: 'Poland' },
  { isoCode: 'PM', name: 'Saint Pierre and Miquelon' },
  { isoCode: 'PN', name: 'Pitcairn' },
  { isoCode: 'PR', name: 'Puerto Rico' },
  { isoCode: 'PS', name: 'Palestine, State of' },
  { isoCode: 'PT', name: 'Portugal' },
  { isoCode: 'PW', name: 'Palau' },
  { isoCode: 'PY', name: 'Paraguay' },
  { isoCode: 'QA', name: 'Qatar' },
  { isoCode: 'RE', name: 'Réunion' },
  { isoCode: 'RO', name: 'Romania' },
  { isoCode: 'RS', name: 'Serbia' },
  { isoCode: 'RU', name: 'Russian Federation' },
  { isoCode: 'RW', name: 'Rwanda' },
  { isoCode: 'SA', name: 'Saudi Arabia' },
  { isoCode: 'SB', name: 'Solomon Islands' },
  { isoCode: 'SC', name: 'Seychelles' },
  { isoCode: 'SD', name: 'Sudan' },
  { isoCode: 'SE', name: 'Sweden' },
  { isoCode: 'SG', name: 'Singapore' },
  { isoCode: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
  { isoCode: 'SI', name: 'Slovenia' },
  { isoCode: 'SJ', name: 'Svalbard and Jan Mayen' },
  { isoCode: 'SK', name: 'Slovakia' },
  { isoCode: 'SL', name: 'Sierra Leone' },
  { isoCode: 'SM', name: 'San Marino' },
  { isoCode: 'SN', name: 'Senegal' },
  { isoCode: 'SO', name: 'Somalia' },
  { isoCode: 'SR', name: 'Suriname' },
  { isoCode: 'SS', name: 'South Sudan' },
  { isoCode: 'ST', name: 'Sao Tome and Principe' },
  { isoCode: 'SV', name: 'El Salvador' },
  { isoCode: 'SX', name: 'Sint Maarten (Dutch part)' },
  { isoCode: 'SY', name: 'Syrian Arab Republic' },
  { isoCode: 'SZ', name: 'Swaziland' },
  { isoCode: 'TC', name: 'Turks and Caicos Islands' },
  { isoCode: 'TD', name: 'Chad' },
  { isoCode: 'TF', name: 'French Southern Territories' },
  { isoCode: 'TG', name: 'Togo' },
  { isoCode: 'TH', name: 'Thailand' },
  { isoCode: 'TJ', name: 'Tajikistan' },
  { isoCode: 'TK', name: 'Tokelau' },
  { isoCode: 'TL', name: 'Timor-Leste' },
  { isoCode: 'TM', name: 'Turkmenistan' },
  { isoCode: 'TN', name: 'Tunisia' },
  { isoCode: 'TO', name: 'Tonga' },
  { isoCode: 'TR', name: 'Turkey' },
  { isoCode: 'TT', name: 'Trinidad and Tobago' },
  { isoCode: 'TV', name: 'Tuvalu' },
  { isoCode: 'TW', name: 'Taiwan, Province of China' },
  { isoCode: 'TZ', name: 'Tanzania, United Republic of' },
  { isoCode: 'UA', name: 'Ukraine' },
  { isoCode: 'UG', name: 'Uganda' },
  { isoCode: 'UM', name: 'United States Minor Outlying Islands' },
  { isoCode: 'UY', name: 'Uruguay' },
  { isoCode: 'UZ', name: 'Uzbekistan' },
  { isoCode: 'VA', name: 'Holy See' },
  { isoCode: 'VC', name: 'Saint Vincent and the Grenadines' },
  { isoCode: 'VE', name: 'Venezuela, Bolivarian Republic of' },
  { isoCode: 'VG', name: 'Virgin Islands, British' },
  { isoCode: 'VI', name: 'Virgin Islands, U.S.' },
  { isoCode: 'VN', name: 'VietNam' },
  { isoCode: 'VU', name: 'Vanuatu' },
  { isoCode: 'WF', name: 'Wallis and Futuna' },
  { isoCode: 'WS', name: 'Samoa' },
  { isoCode: 'YE', name: 'Yemen' },
  { isoCode: 'YT', name: 'Mayotte' },
  { isoCode: 'ZA', name: 'South Africa' },
  { isoCode: 'ZM', name: 'Zambia' },
  { isoCode: 'ZW', name: 'Zimbabwe' },
];

export default countryMap;

const getCountryByIsoCode = isoCode => {
  if (isoCode === null || !isoCode) return undefined;
  return countryMap.find(country => country.isoCode === isoCode);
};

export const getCountryNameByIsoCode = isoCode => {
  const country = getCountryByIsoCode(isoCode);
  return country ? country.name : undefined;
};

export const getCountryIndexByIsoCode = isoCode => {
  if (!isoCode) return -1;
  return countryMap.findIndex(country => country.isoCode === isoCode);
};
